import React, { useState } from "react";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  Category,
  PostAdd,
  Article,
  Edit,
  PeopleAlt,
} from "@mui/icons-material";

import ECategory from "./ECategory";
import EPages from "./EPages";
import EPost from "./EPost";
import EEdit from "./EDIT/EEdit";
import SEOManager from "./SEOManager";
import SocialHandles from "./SocialHandles"; // ✅ Added

const Editorial: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "category" | "pages" | "post" | "edit" | "seo" | "social"
  >("category");
  const [menuOpen, setMenuOpen] = useState(false);

  const renderContent = () => {
    switch (activeTab) {
      case "category":
        return <ECategory />;
      case "pages":
        return <EPages />;
      case "post":
        return <EPost />;
      case "edit":
        return <EEdit />;
      case "seo":
        return <SEOManager />;
      case "social":
        return <SocialHandles />; // ✅ Added
      default:
        return <ECategory />;
    }
  };

  return (
    <div style={styles.page}>
      {/* Header */}
      <header style={styles.header}>
        <button
          onClick={() => setMenuOpen(true)}
          style={{ ...styles.menuButton, zIndex: 2001 }}
        >
          <MenuIcon fontSize="large" style={{ color: "#fff" }} />
        </button>
      </header>

      {/* Fullscreen Side Menu */}
      {menuOpen && (
        <div style={styles.fullMenu}>
          <button onClick={() => setMenuOpen(false)} style={styles.closeButton}>
            <CloseIcon fontSize="large" style={{ color: "#fff" }} />
          </button>
          <h2 style={styles.menuTitle}>Menu</h2>
        </div>
      )}

      {/* Footer Tabs */}
      <div style={styles.tabs}>
        <div
          style={activeTab === "category" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("category")}
        >
          <Category style={styles.icon} />
          <span>Category</span>
        </div>
        <div
          style={activeTab === "pages" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("pages")}
        >
          <Article style={styles.icon} />
          <span>Pages</span>
        </div>
        <div
          style={activeTab === "post" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("post")}
        >
          <PostAdd style={styles.icon} />
          <span>Post</span>
        </div>
        <div
          style={activeTab === "edit" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("edit")}
        >
          <Edit style={styles.icon} />
          <span>Edit</span>
        </div>
        <div
          style={activeTab === "seo" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("seo")}
        >
          <span style={styles.icon}>🧠</span>
          <span>SEO</span>
        </div>
        <div
          style={activeTab === "social" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("social")}
        >
          <PeopleAlt style={styles.icon} />
          <span>Social</span>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default Editorial;

const HEADER_HEIGHT = 70;
const TABS_HEIGHT = 60;

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    backgroundColor: "#000",
    color: "#fff",
    minHeight: "100vh",
    overflowX: "hidden",
    position: "relative",
  },
  header: {
    height: HEADER_HEIGHT,
    background: "rgba(0,0,0,0.8)",
    backdropFilter: "blur(8px)",
    borderBottom: "1px solid #333",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1000,
  },
  logo: {
    height: 40,
  },
  menuButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    background: "none",
    border: "none",
    cursor: "pointer",
    zIndex: 2001,
  },
  fullMenu: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background:
      "linear-gradient(135deg, #4c1d95, #6b21a8, #7c3aed, #a78bfa, #2d2d2d)",
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menuTitle: {
    fontSize: "32px",
    fontWeight: 700,
    color: "#fff",
    textAlign: "center",
  },
  tabs: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    height: TABS_HEIGHT,
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    background: "#111",
    borderTop: "1px solid #333",
    zIndex: 999,
  },
  tab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#aaa",
    fontSize: 12,
    cursor: "pointer",
  },
  activeTab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#a855f7",
    fontWeight: "bold",
    fontSize: 12,
    cursor: "pointer",
  },
  icon: {
    fontSize: 24,
    marginBottom: 4,
  },
  content: {
    padding: `${HEADER_HEIGHT + 20}px 20px ${TABS_HEIGHT + 20}px`,
  },
};
